import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLocalStock } from "../../../../api";
import "./local-stock-bar.css";

const formatQuantity = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return "";
  }

  return number.toLocaleString("pl-PL", {
    maximumFractionDigits: 4,
    minimumFractionDigits: 0,
  });
};

const LocalStockBar = ({ active = true }) => {
  const { product_slug } = useParams();
  const [stock, setStock] = useState(null);

  useEffect(() => {
    if (!active || !product_slug) {
      setStock(null);
      return undefined;
    }

    let cancelled = false;
    setStock(null);

    getLocalStock(product_slug).then((data) => {
      if (!cancelled) {
        setStock(data);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [active, product_slug]);

  if (
    stock == null ||
    stock.quantity === null ||
    stock.quantity === undefined ||
    stock.unit == null ||
    stock.unit === ""
  ) {
    return null;
  }

  const isEmpty = Number(stock.quantity) === 0;
  const quantityLabel = formatQuantity(stock.quantity);

  return (
    <div
      className={`local-stock-bar ${isEmpty ? "is-empty" : "is-available"}`}
    >
      Na magazynie w Hajnówce: {quantityLabel} {stock.unit}
    </div>
  );
};

export default LocalStockBar;
